export default __webpack_public_path__ + "static/7-finance-d95d98c4512679c3b2d1351f11066430.jpg";